import urlParser from 'bloko/common/urlParser';

import fetchInvoices from 'components/Admin/Invoices/Filter/fetchInvoices';

import {
    InvoiceFilterType,
    INVOICES_INITIAL_STATE,
    setDates,
    setFilterType,
    setFilterValue,
} from 'store/models/invoices';

export default () => (dispatch, getState) => {
    const { invoices } = getState();
    const url = urlParser(document.location.href);
    const { params } = url;
    const from = params.dateFrom ? new Date(params.dateFrom[0]) : invoices.from;
    const to = params.dateTo ? new Date(params.dateTo[0]) : invoices.to;
    if (params.type?.length > 0 && params.value?.length > 0) {
        const filterType = params.type[0];
        const filterValue = params.value[0];
        dispatch([setDates({ from, to }), setFilterType(filterType), setFilterValue(filterValue)]);
        dispatch(fetchInvoices(from, to, filterType, filterValue));
    } else {
        if (params.dateFrom?.length > 0 && params.dateTo?.length > 0) {
            dispatch(setDates({ from, to }));
        }
        dispatch(
            fetchInvoices(
                INVOICES_INITIAL_STATE.from,
                INVOICES_INITIAL_STATE.to,
                InvoiceFilterType.Status,
                'waiting_doc',
                true
            )
        );
    }
};
